import { render, staticRenderFns } from "./KarmaRequestEditForm.vue?vue&type=template&id=5fdbc45c&"
import script from "./KarmaRequestEditForm.vue?vue&type=script&lang=js&"
export * from "./KarmaRequestEditForm.vue?vue&type=script&lang=js&"
import style0 from "./KarmaRequestEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports